import employeeBlocksNavigationComponentUrl from './employeeBlocksNavigationComponent.html';

class EmployeeBlocksNavigationCtrl {
  constructor(Authentication) {
    'ngInject';

    Object.assign(this, { Authentication });
  }

  get user() {
    return this.Authentication.user;
  }

  get timesheetsLockedForPremium() {
    return (
      !this.Authentication.user.org.isPremium &&
      this.Authentication.user.orgSettings.premiumFeatures.clockIn
    );
  }

  get showUnavailabilityBlock() {
    return this.Authentication.user.orgSettings.usersSetAvailability;
  }
}

export default {
  templateUrl: employeeBlocksNavigationComponentUrl,
  controllerAs: 'ctrl',
  controller: EmployeeBlocksNavigationCtrl,
};
